import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';

import { TercerosVigentesCapitalAcumuladoComponent } from './TercerosVigentesCapitalAcumulado.component';


import { RoleGuardService as RoleGuard } from '../Seguridad/role-guard.service';





const routes = [
    {
        path     : 'TercerosVigentesCapitalAcumulado',
        component: TercerosVigentesCapitalAcumuladoComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'TercerosVigentesCapitalAcumulado',
          nombreFormulario : 'SaldoIndemTercerosVigentesCapitalFechaCortenizaciones'
        } 
    }
];

@NgModule({
    declarations: [
        TercerosVigentesCapitalAcumuladoComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        TercerosVigentesCapitalAcumuladoComponent
    ]
})

export class TercerosVigentesCapitalAcumuladoModule
{
}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/TercerosVigentesCapitalAcumulado/TercerosVigentesCapitalAcumulado.module.ts